
  if ('scrollRestoration' in history) {

      history.scrollRestoration = 'manual';
  }
  

window.addEventListener('DOMContentLoaded', function () {
    const loaderButton = document.querySelectorAll('.loader');
    const grid = document.querySelector('.grid');
    

    class AjaxLoader {
        constructor(el, options) {
            let defaultOptions = {
                direction: 'forward',
                page: 1
            }
            this.element = el;
            this.options = Object.assign(
                {},
                defaultOptions,
                options
            );

            this.element.addEventListener('click', (e) => {
                if (!this.element.classList.contains('loading')) {
                    this.loadPosts()
                }
            })
        }
        
        
        loadPosts() {
            this.element.classList.add('loading');
            const targetPage = this.getPage(this.options.page);
            const topi = this.element.offsetTop;
            this.scrollTo(topi);
            fetch(`${this.options.ajaxUrl}?` + new URLSearchParams({
                action: 'ajax_pagination',
                per_page: 8,    
                page: targetPage
            })).then((response) => {
                return response.json();
            }).then((data) => {
                this.setUrl(targetPage);
                this.handledResponse(data);
            }).catch(function (err) {
                console.warn('Something went wrong.', err);
            }); 
        }

        getPage(i) {
            if (this.options.direction === 'forward') {
                return i+1
            } else {
                return i-1
            }
        }

        scrollTo(topi) {
            
            window.scroll({
                top: parseInt(topi, 10) + 100,
                behavior: 'smooth'
            });
        }

        
        setUrl(pageId) {
           
            if (parseInt(pageId, 10) > 1) {
                window.history.replaceState({}, '', `/blog/page/${pageId}/`);  
            } else {
                window.history.replaceState({}, '', '/blog/');  
            }
        }

        handledResponse(data) {
            const position = (this.options.direction === 'forward') ? 'beforeend' : 'afterbegin'; 
            grid.insertAdjacentHTML(position, data.data.response);
            this.element.classList.remove('loading');
            this.options.page = data.data.current;
            
            if (data.data.current === data.data.total || data.data.current === 1) {
                this.element.remove()
            }
        }
    }

    if (loaderButton.length > 0) {
        loaderButton.forEach((button, i) => {
            const loader = new AjaxLoader(button, {
                page: parseInt(button.dataset['paged'], 10), 
                ajaxUrl: window.urls.ajax,
                direction: button.dataset['direction']
            });
        })
    }
});